module.exports = __webpack_public_path__ + "img/hands-bubbles.274bc388.svg";